module.exports = __webpack_public_path__ + "img/addressBook.1cb1bf8f.png";